module.exports = __webpack_public_path__ + "img/613.Frodktim.1d4c06c5.svg";